'use client';

import { LinkContext, type Routes } from '@lichtblick/link/helpers/link-context';
import type { FC, PropsWithChildren } from 'react';

const APP_ROUTES: Routes = {
  externalRoutes: {
    absolute: [],
    catchAll: [],
  },
  internalRoutes: {
    absolute: [],
    catchAll: ['/checkout-b2b/'],
  },
};

export const LinkContextProvider: FC<PropsWithChildren> = ({ children }) => (
  <LinkContext.Provider value={APP_ROUTES}>{children}</LinkContext.Provider>
);
